// extracted by mini-css-extract-plugin
export var ldsDefault = "_redotech-redo-customer-portal-returns-app-lib-returns-spinner-lds-default";